(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky = this.getAttribute('data-sticky-type') === 'always' || this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      };

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => this.preventReveal = true;

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');      
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach(disclosure => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["vessa-outdoor"] && !Shopify.designMode) return;
  try {
    
(() => {
  const init = root => {
    if (!root || root.dataset.ready) return;
    root.dataset.ready = 'true';
    const money = value => new Intl.NumberFormat('pt-PT', {style:'currency',currency:'EUR'}).format(value / 100);
    const add = async (form, items) => {
      const button = form.querySelector('button[type="submit"]');
      const message = form.querySelector('.vo-form-message');
      const original = button.innerHTML;
      if (button.disabled) return;
      button.disabled = true;
      button.textContent = root.dataset.adding;
      message.textContent = '';
      try {
        const response = await fetch(root.dataset.cartAdd, {method:'POST',headers:{'Content-Type':'application/json','Accept':'application/json'},body:JSON.stringify({items,sections:['cart-drawer','cart-icon-bubble'],sections_url:window.location.pathname})});
        const data = await response.json();
        if (!response.ok) throw new Error(data.description || root.dataset.error);
        message.textContent = root.dataset.added;
        form.querySelector('.vo-cart-actions').hidden = false;
        const drawer = document.querySelector('cart-drawer');
        if (drawer && typeof drawer.renderContents === 'function' && data.sections && data.sections['cart-drawer'] && data.sections['cart-icon-bubble']) {
          try {
            drawer.classList.remove('is-empty');
            drawer.setActiveElement(button);
            drawer.renderContents(data);
          } catch (_) {}
        }
        document.dispatchEvent(new CustomEvent('vessa:outdoor-added', {detail:{items:data.items}}));
      } catch (error) {
        message.textContent = root.dataset.error;
      } finally {
        button.disabled = false;
        button.innerHTML = original;
      }
    };
    root.querySelectorAll('.vo-buy').forEach(form => {
      form.addEventListener('submit', event => {
        event.preventDefault();
        const id = form.querySelector('[name="id"]').value;
        if (id) add(form, [{id,quantity:1}]);
      });
    });
    const builder = root.querySelector('.vo-builder');
    const selected = () => [...builder.querySelectorAll('.vo-builder-item')].filter(card => card.querySelector('.vo-pick').checked).map(card => card.querySelector('select').selectedOptions[0]);
    builder.addEventListener('change', () => {
      builder.querySelector('.vo-total').textContent = money(selected().reduce((sum, option) => sum + Number(option.dataset.price), 0));
    });
    builder.addEventListener('submit', event => {
      event.preventDefault();
      const options = selected();
      if (!options.length) {builder.querySelector('.vo-form-message').textContent = root.dataset.empty;return;}
      add(builder, options.map(option => ({id:option.value,quantity:1})));
    });
  };
  document.querySelectorAll('.vo').forEach(init);
  document.addEventListener('shopify:section:load', event => init(event.target.querySelector('.vo')));
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["vessa-pdp-dr"] && !Shopify.designMode) return;
  try {
    
(function(){
  var roots = document.querySelectorAll('[data-vdr]');
  Array.prototype.forEach.call(roots, function(root){
    if (root.dataset.vdrReady) return;
    root.dataset.vdrReady = '1';

    var form     = root.querySelector('form');
    var vidInput = root.querySelector('[data-vdr-vid]');
    var atc      = root.querySelector('[data-vdr-atc]');
    var atcLabel = root.querySelector('[data-vdr-atc-label]');
    var errEl    = root.querySelector('[data-vdr-err]');
    var shipEl   = root.querySelector('[data-vdr-ship]');
    var sticky   = root.querySelector('[data-vdr-sticky]');
    var blob     = root.parentNode.querySelector('[data-vdr-variants]')
                   || document.querySelector('[data-vdr-variants]');

    var variants = [];
    try { variants = JSON.parse(blob.textContent); } catch(e){ variants = []; }

    var cfg = {
      t2: parseFloat(root.dataset.tier2 || '10'),
      t3: parseFloat(root.dataset.tier3 || '20'),
      shipMin: parseFloat(root.dataset.shipmin || '3900')
    };

    /* ---------- money ---------- */
    function money(cents){
      return (cents/100).toLocaleString('pt-PT',{style:'currency',currency:'EUR'});
    }

    /* ---------- gallery ---------- */
    var slides = root.querySelector('[data-vdr-slides]');
    var dots   = root.querySelectorAll('[data-vdr-dot]');
    if (slides && dots.length){
      Array.prototype.forEach.call(dots, function(d){
        d.addEventListener('click', function(){
          var i = parseInt(d.getAttribute('data-vdr-dot'),10);
          slides.scrollTo({left: slides.clientWidth*i, behavior:'smooth'});
        });
      });
      slides.addEventListener('scroll', function(){
        var i = Math.round(slides.scrollLeft / Math.max(slides.clientWidth,1));
        Array.prototype.forEach.call(dots, function(d,j){
          d.classList.toggle('is-on', j===i);
        });
      }, {passive:true});
    }

    /* ---------- variant matching ---------- */
    function chosenOptions(){
      var out = [];
      root.querySelectorAll('[data-vdr-opt]').forEach(function(group){
        var i = group.getAttribute('data-vdr-opt');
        var sel = group.querySelector('input[data-vdr-val="'+i+'"]:checked');
        out[parseInt(i,10)] = sel ? sel.value : null;
      });
      return out;
    }

    function currentVariant(){
      if (!variants.length) return null;
      var picked = chosenOptions();
      if (!picked.length) return variants[0];
      for (var i=0;i<variants.length;i++){
        var ok = true;
        for (var j=0;j<picked.length;j++){
          if (picked[j] == null) { ok = false; break; }
          if (variants[i].options[j] !== picked[j]) { ok = false; break; }
        }
        if (ok) return variants[i];
      }
      return null;
    }

    /* ---------- greying out unavailable values ---------- */
    function refreshAvailability(){
      var picked = chosenOptions();
      root.querySelectorAll('[data-vdr-opt]').forEach(function(group){
        var gi = parseInt(group.getAttribute('data-vdr-opt'),10);
        group.querySelectorAll('input[data-vdr-val]').forEach(function(input){
          var trial = picked.slice();
          trial[gi] = input.value;
          var exists = variants.some(function(vr){
            if (!vr.available) return false;
            for (var k=0;k<trial.length;k++){
              if (trial[k] == null) continue;
              if (k === gi && vr.options[k] !== trial[k]) return false;
              if (k !== gi && vr.options[k] !== trial[k]) return false;
            }
            return true;
          });
          input.disabled = !exists;
        });
      });
    }

    /* ---------- tier pricing ---------- */
    function activeQty(){
      var r = root.querySelector('input[name="quantity"]:checked');
      return r ? parseInt(r.value,10) : 1;
    }

    function repriceTiers(){
      var vr = currentVariant();
      var unit = vr ? vr.price : (variants[0] ? variants[0].price : 0);
      var pcts = {1:0, 2:cfg.t2, 3:cfg.t3};
      [1,2,3].forEach(function(q){
        var total = Math.round(unit * q * (100 - pcts[q]) / 100);
        var each  = Math.round(total / q);
        var save  = (unit * q) - total;
        var tEl = root.querySelector('[data-vdr-total="'+q+'"]');
        var eEl = root.querySelector('[data-vdr-each="'+q+'"]');
        var sEl = root.querySelector('[data-vdr-save="'+q+'"]');
        if (tEl) tEl.textContent = money(total);
        if (eEl) eEl.textContent = money(each) + ' / par';
        if (sEl) sEl.textContent = 'poupa ' + money(save);
      });
      return unit;
    }

    function refreshShipping(unit){
      var q = activeQty();
      var pcts = {1:0, 2:cfg.t2, 3:cfg.t3};
      var total = Math.round(unit * q * (100 - pcts[q]) / 100);
      if (shipEl){
        if (total >= cfg.shipMin){
          shipEl.textContent = 'Envio grátis incluído';
          shipEl.hidden = false;
        } else {
          shipEl.textContent = 'Faltam ' + money(cfg.shipMin - total) + ' para envio grátis';
          shipEl.hidden = false;
        }
      }
      var st = root.querySelector('[data-vdr-sticky-total]');
      var ss = root.querySelector('[data-vdr-sticky-sub]');
      if (st) st.textContent = money(total);
      if (ss) ss.textContent = q + (q === 1 ? ' par' : ' pares');
    }

    function syncAll(){
      refreshAvailability();
      var unit = repriceTiers();
      refreshShipping(unit);
      var vr = currentVariant();
      if (vr && vidInput) vidInput.value = vr.id;
      if (errEl && vr) { errEl.hidden = true; }
      if (atc){
        if (vr && !vr.available){
          atc.setAttribute('disabled','disabled');
          if (atcLabel) atcLabel.textContent = 'Esgotado neste tamanho';
        } else {
          atc.removeAttribute('disabled');
          if (atcLabel) atcLabel.textContent = atc.dataset.label || atcLabel.textContent;
        }
      }
    }

    if (atc && atcLabel) atc.dataset.label = atcLabel.textContent.trim();

    root.addEventListener('change', function(e){
      if (e.target.matches('input[data-vdr-val], input[name="quantity"]')) syncAll();
    });

    /* ---------- size guide ---------- */
    var sheet = root.querySelector('[data-vdr-sheet]');
    root.querySelectorAll('[data-vdr-guide]').forEach(function(b){
      b.addEventListener('click', function(){ if (sheet) sheet.hidden = false; });
    });
    root.querySelectorAll('[data-vdr-sheet-close]').forEach(function(b){
      b.addEventListener('click', function(){ if (sheet) sheet.hidden = true; });
    });
    document.addEventListener('keydown', function(e){
      if (e.key === 'Escape' && sheet && !sheet.hidden) sheet.hidden = true;
    });

    /* ---------- sticky bar ---------- */
    if (sticky && atc){
      if ('IntersectionObserver' in window){
        new IntersectionObserver(function(entries){
          sticky.hidden = entries[0].isIntersecting;
        }, {rootMargin: '-80px 0px 0px 0px'}).observe(atc);
      }
      var sAtc = root.querySelector('[data-vdr-sticky-atc]');
      if (sAtc) sAtc.addEventListener('click', function(){
        var missing = chosenOptions().some(function(x){ return x == null; });
        if (missing || window.innerWidth < 750){
          atc.scrollIntoView({behavior:'smooth', block:'center'});
          setTimeout(function(){ atc.click(); }, 420);
        } else { atc.click(); }
      });
    }

    /* ---------- ADD TO CART ----------
       Native form POST is the fallback. JS enhances it.
       Watchdog: if no drawer/cart signal in 1500ms, hard-navigate to /cart.
    ------------------------------------ */
    if (form && atc){
      form.addEventListener('submit', function(e){
        var vr = currentVariant();

        if (!vr){
          e.preventDefault();
          if (errEl){
            errEl.textContent = 'Escolha o tamanho para continuar.';
            errEl.hidden = false;
            errEl.scrollIntoView({behavior:'smooth', block:'center'});
          }
          return;
        }
        if (!vr.available){ e.preventDefault(); return; }

        if (!window.fetch) return;   // let the native POST run

        e.preventDefault();
        atc.setAttribute('aria-busy','true');
        if (atcLabel) atcLabel.textContent = 'A adicionar…';

        var settled = false;
        var watchdog = setTimeout(function(){
          if (!settled) window.location.href = '/cart';
        }, 1500);

        fetch('/cart/add.js', {
          method: 'POST',
          headers: {'Content-Type':'application/json','Accept':'application/json'},
          body: JSON.stringify({ id: vr.id, quantity: activeQty() })
        })
        .then(function(r){ if(!r.ok) throw new Error('add failed'); return r.json(); })
        .then(function(){
          settled = true;
          clearTimeout(watchdog);

          document.dispatchEvent(new CustomEvent('cart:refresh', {bubbles:true}));
          document.dispatchEvent(new CustomEvent('cart:open',    {bubbles:true}));

          var drawer = document.querySelector('cart-drawer, #CartDrawer, .cart-drawer, [id*="cart-drawer"]');
          var opened = false;
          if (drawer){
            if (typeof drawer.open === 'function'){ try{ drawer.open(); opened = true; }catch(err){} }
            else { drawer.classList.add('active','is-open','open'); drawer.removeAttribute('hidden'); opened = true; }
          }
          if (!opened){ window.location.href = '/cart'; return; }

          atc.removeAttribute('aria-busy');
          if (atcLabel) atcLabel.textContent = atc.dataset.label;
        })
        .catch(function(){
          settled = true;
          clearTimeout(watchdog);
          form.submit();   // native POST as last resort
        });
      });
    }

    syncAll();
  });
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["vessa-pdp-footer"] && !Shopify.designMode) return;
  try {
    
document.querySelectorAll('.vf-columns details').forEach(d=>{if(matchMedia('(max-width:749px)').matches)d.open=false});

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["vessa-pdp-offer"] && !Shopify.designMode) return;
  try {
    
if(!customElements.get('vessa-pdp'))customElements.define('vessa-pdp',class extends HTMLElement{
connectedCallback(){if(this.ready)return;this.ready=true;this.d=JSON.parse(this.querySelector('.vs-data').textContent);this.variants=this.d.variants;this.initial=this.variants.find(v=>v.id===this.d.initial)||this.variants[0];this.colorIndex=Number(this.dataset.colorIndex);this.options=[...this.initial.options];this.colors=[];this.index=0;this.pending=false;this.money=new Intl.NumberFormat(this.dataset.locale||'pt-PT',{style:'currency',currency:this.dataset.currency||'EUR'});this.track=this.querySelector('.vs-track');this.slides=[...this.querySelectorAll('.vs-slide')];this.offers=[...this.querySelectorAll('.vs-offer')];this.offer=this.offers.find(x=>Number(x.dataset.qty)===Number(this.dataset.defaultPack))||this.offers[0];this.qty=Number(this.offer?.dataset.qty||1);this.colors=Array(3).fill(this.options[this.colorIndex]);this.addEventListener('click',e=>this.click(e));this.querySelector('.vs-form').addEventListener('submit',e=>{e.preventDefault();this.add()});let timer;this.track.addEventListener('scroll',()=>{clearTimeout(timer);timer=setTimeout(()=>{this.index=Math.round(this.track.scrollLeft/this.track.clientWidth);this.syncGallery()},80)});this.buildColors();this.update();this.syncGallery();this.syncSticky=()=>{const sticky=this.querySelector('.vs-sticky');if(sticky)sticky.hidden=this.querySelector('.vs-form').getBoundingClientRect().bottom>0;};window.addEventListener('scroll',this.syncSticky,{passive:true});this.syncSticky();this.querySelectorAll('dialog').forEach(dialog=>{dialog.addEventListener('click',e=>{if(e.target===dialog)dialog.close()})});}
disconnectedCallback(){window.removeEventListener('scroll',this.syncSticky);this.observer?.disconnect()}
fmt(cents){return this.money.format(cents/100)}
selected(unit){const options=[...this.options];if(this.colorIndex>=0)options[this.colorIndex]=this.colors[unit];return this.variants.find(v=>v.options.every((x,i)=>x===options[i]))}
buildColors(){if(this.colorIndex<0)return;const host=this.querySelector('.vs-color-rows');host.replaceChildren();const values=[...new Set(this.variants.map(v=>v.options[this.colorIndex]))];for(let unit=0;unit<this.qty;unit++){const row=document.createElement('div');row.className='vs-color-row';const photo=document.createElement('img');photo.className='vs-color-preview';photo.width=52;photo.height=70;photo.alt=this.colors[unit];const v=this.selected(unit)||this.variants.find(v=>v.options[this.colorIndex]===this.colors[unit]);photo.src=v?.featured_image?.src||this.d.fallback;row.append(photo);const content=document.createElement('div');const heading=document.createElement('p');heading.className='vs-color-title';heading.append(document.createTextNode(this.d.colorLabel+': '));const strong=document.createElement('b');strong.textContent=this.colors[unit];heading.append(strong);content.append(heading);const swatches=document.createElement('div');swatches.className='vs-swatches';for(const color of values){const button=document.createElement('button');button.type='button';button.className='vs-swatch';button.dataset.unit=unit;button.dataset.color=color;button.setAttribute('aria-label',this.d.unitLabel+' '+(unit+1)+': '+color);button.title=color;button.setAttribute('aria-pressed',color===this.colors[unit]);const variant=this.variants.find(v=>v.options[this.colorIndex]===color&&v.featured_image);const img=document.createElement('img');img.src=variant?.featured_image?.src||this.d.fallback;img.alt=color;img.loading='lazy';button.append(img);const options=[...this.options];options[this.colorIndex]=color;const match=this.variants.find(v=>v.options.every((x,i)=>x===options[i]));if(!match?.available)button.classList.add('is-unavailable');swatches.append(button)}content.append(swatches);row.append(content);host.append(row)}this.querySelector('.vs-color-summary').textContent=this.colors.slice(0,this.qty).join(', ')}
totals(qty,pct){let total=0,compare=0;for(let i=0;i<qty;i++){const v=this.selected(i)||this.initial;total+=v.price;compare+=Math.max(v.price,v.compare_at_price||0)}return {total:Math.round(total*(100-pct)/100),compare}}
update(){if(!this.offer)return;this.offers.forEach(offer=>{const q=Number(offer.dataset.qty),pct=Number(offer.dataset.discount);const t=this.totals(q,pct),saving=t.compare-t.total;offer.setAttribute('aria-pressed',offer===this.offer);offer.querySelector('.vs-unit-price').textContent=this.fmt(t.total/q);offer.querySelector('.vs-compare').textContent=saving>0?this.fmt(t.compare):'';offer.querySelector('.vs-save').hidden=saving<=0;offer.querySelector('.vs-save span').textContent=this.fmt(saving)});this.querySelector('.vs-chosen-offer').textContent=this.offer.dataset.title;const chosen=Array.from({length:this.qty},(_,i)=>this.selected(i));this.valid=chosen.every(v=>v&&v.available);const atc=this.querySelector('.vs-form .vs-atc');atc.disabled=!this.valid||this.pending;atc.firstElementChild.textContent=this.valid?this.d.atc:this.d.soldOut;const t=this.totals(this.qty,Number(this.offer.dataset.discount));const percent=t.compare>t.total?Math.round((t.compare-t.total)*100/t.compare):0;atc.lastElementChild.textContent=percent?this.d.save+' '+percent+'%':this.fmt(t.total);const discountNote=this.querySelector('.vs-discount-note');discountNote.hidden=Number(this.offer.dataset.discount)===0;discountNote.textContent=this.offer.dataset.automatic==='true'?discountNote.dataset.autoNote:discountNote.dataset.codeNote;this.querySelectorAll('.vs-option').forEach(group=>{const n=Number(group.dataset.option);group.querySelector('.vs-option-value').textContent=this.options[n];group.querySelectorAll('button').forEach(button=>{button.setAttribute('aria-pressed',button.dataset.value===this.options[n]);const match=this.variants.some(v=>v.available&&v.options.every((x,i)=>i===n?x===button.dataset.value:i===this.colorIndex?x===this.colors[0]:x===this.options[i]));button.classList.toggle('is-unavailable',!match)})});const first=chosen[0];if(first){this.querySelector('input[name=id]').value=first.id;const url=new URL(location.href);url.searchParams.set('variant',first.id);history.replaceState({},'',url)}this.querySelector('input[name=quantity]').value=this.qty;const sticky=this.querySelector('.vs-sticky-price');if(sticky)sticky.textContent=this.fmt(t.total);const stickyButton=this.querySelector('.vs-sticky-button');if(stickyButton){stickyButton.disabled=!this.valid;stickyButton.textContent=this.valid?this.d.atc:this.d.soldOut}this.querySelector('.vs-error').hidden=true;}
click(e){const b=e.target.closest('button');if(!b)return;if(b.matches('[data-slide]'))this.go(Number(b.dataset.slide));if(b.matches('.vs-next'))this.go(this.index+1);if(b.matches('.vs-prev'))this.go(this.index-1);if(b.matches('.vs-offer')){this.offer=b;this.qty=Number(b.dataset.qty);this.buildColors();this.update()}if(b.matches('.vs-swatch')){this.colors[Number(b.dataset.unit)]=b.dataset.color;this.buildColors();this.update();const v=this.selected(Number(b.dataset.unit));if(v?.featured_media){const index=this.slides.findIndex(x=>x.dataset.mediaId==v.featured_media.id);if(index>=0)this.go(index)}}if(b.closest('.vs-option')){this.options[Number(b.closest('.vs-option').dataset.option)]=b.dataset.value;this.buildColors();this.update()}if(b.matches('.vs-size-link,.vs-size-preview'))this.querySelector('.vs-size-dialog').showModal();if(b.matches('.vs-zoom')){const dialog=this.querySelector('.vs-zoom-dialog');dialog.querySelector('img').src=this.slides[this.index].dataset.image;dialog.showModal()}if(b.matches('.vs-close'))b.closest('dialog').close();if(b.matches('.vs-sticky-button'))this.add()}
go(index){this.index=(index+this.slides.length)%this.slides.length;this.track.scrollTo({left:this.index*this.track.clientWidth,behavior:'smooth'});this.syncGallery()}
syncGallery(){if(this.dataset.imageRatio==='adapt'){const ratio=Number(this.slides[this.index]?.dataset.ratio);if(ratio>0)this.style.setProperty('--vs-ratio',ratio);}this.querySelectorAll('[data-slide]').forEach(b=>b.setAttribute('aria-pressed',Number(b.dataset.slide)===this.index));this.slides.forEach((slide,i)=>{slide.querySelectorAll('video').forEach(v=>{if(i!==this.index)v.pause();else if(this.dataset.autoplayVideos==='true'){v.muted=true;v.loop=true;v.playsInline=true;v.play().catch(()=>{})}})})}
async add(){if(this.pending||!this.valid)return;this.pending=true;const button=this.querySelector('.vs-form .vs-atc');button.disabled=true;button.firstElementChild.textContent=this.d.loading;const items=[];for(let i=0;i<this.qty;i++){const v=this.selected(i);const found=items.find(item=>item.id===v.id);if(found)found.quantity++;else items.push({id:v.id,quantity:1})}try{const response=await fetch(this.dataset.root+'cart/add.js',{method:'POST',headers:{'Content-Type':'application/json','Accept':'application/json'},body:JSON.stringify({items})});const data=await response.json();if(!response.ok)throw new Error(data.description||this.d.stock);const code=this.offer.dataset.code;location.href=code?this.dataset.root+'discount/'+encodeURIComponent(code)+'?redirect='+encodeURIComponent(this.dataset.root+'cart'):this.dataset.root+'cart'}catch(error){this.pending=false;this.update();const message=this.querySelector('.vs-error');message.textContent=error.message||this.d.error;message.hidden=false;this.querySelector('.vs-form').scrollIntoView({behavior:'smooth',block:'center'})}}
});

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["vessa-pdp-reviews"] && !Shopify.designMode) return;
  try {
    
if(!customElements.get('vessa-reviews'))customElements.define('vessa-reviews',class extends HTMLElement{connectedCallback(){if(this.ready)return;this.ready=true;this.querySelectorAll('.vr-copy').forEach(p=>{if(p.textContent.length>200)p.nextElementSibling.hidden=false});this.addEventListener('click',e=>{const b=e.target.closest('button');if(!b)return;if(b.matches('.vr-more')){b.previousElementSibling.classList.add('expanded');b.hidden=true}if(b.matches('.vs-close'))b.closest('dialog').close();if(b.dataset.review){const row=this.querySelector('[data-review-id="'+b.dataset.review+'"]');if(!row)return;const d=this.querySelector('dialog');d.querySelector('img').src=row.querySelector('img').src;d.querySelector('h3').textContent=row.querySelector('header b').textContent;d.querySelector('p').textContent=row.querySelector('.vr-copy').textContent;d.showModal()}});this.querySelector('dialog').addEventListener('click',e=>{if(e.target.tagName==='DIALOG')e.target.close()});this.querySelector('select')?.addEventListener('change',e=>{const list=this.querySelector('.vr-list'),rows=[...list.children];rows.sort((a,b)=>e.target.value==='rating'?Number(b.dataset.rating)-Number(a.dataset.rating):e.target.value==='newest'?b.dataset.date.localeCompare(a.dataset.date):Number(a.dataset.original)-Number(b.dataset.original));rows.forEach(row=>list.append(row))});[...this.querySelector('.vr-list').children].forEach((r,i)=>r.dataset.original=i)}});

  } catch(e) { console.error(e); }
})();
})();
